module.exports = __webpack_public_path__ + "static/media/TP_Icon_PortableCharger.39651710.png";